<script module lang="ts">
  import type { Icon } from 'lucide-svelte';
  import { type AllowedIcon, type IconProps as Props } from './icons.types';
</script>

<script lang="ts">
  import * as Icons from 'lucide-svelte';

  const { icon, size = 0.8, children }: Props = $props();

  const IconsMapper = {
    save: Icons.Save,
    cancel: Icons.X,
    settings: Icons.Settings,
  } satisfies Record<AllowedIcon, typeof Icon>;

  const IconComp = $derived(typeof icon === 'string' ? IconsMapper[icon] : icon);
  const IconSize = $derived(Math.min(Math.max(0.1, size), 5));
  const IconLabel = $derived(children);
  const HasLabel = $derived(!!IconLabel);
</script>

<span class="lyIconWrapper {HasLabel && 'lyIconWithLabel'}" style:--style-size={IconSize}>
  <IconComp class="lyIconsInlay" />
  {#if IconLabel}
    <span class="lyIconLabel">{@render IconLabel()}</span>
  {/if}
</span>

<style lang="scss">
  .lyIconWrapper {
    :global(.lyIconsInlay) {
      width: calc(var(--style-size, 1) * 1em);
      height: auto;
      margin: 0;
      padding: 0;
    }

    &.lyIconWithLabel {
      display: inline-flex;
      align-items: center;
      gap: 0.25em;

      :global(.lyIconsInlay) {
        flex-shrink: 0;
      }
    }
  }
</style>
